import React, { useEffect, useState } from "react";
import { Container } from "react-bootstrap";
import { FiMinus } from "react-icons/fi";
import Button from "../Buttons/Button";
import "./Calculation.sass";
import Image from '../../assets/images/image2.png'
import { BsPlus } from "react-icons/bs";

import image1 from "../../assets/quickImages/1.png"
import image2 from "../../assets/quickImages/2.png"
import image3 from "../../assets/quickImages/3.png"
import image4 from "../../assets/quickImages/4.png"
import image5 from "../../assets/quickImages/5.png"
import image6 from "../../assets/quickImages/6.png"
import image7 from "../../assets/quickImages/7.png"
import image8 from "../../assets/quickImages/8.png"
import image9 from "../../assets/quickImages/9.png"
import image10 from "../../assets/quickImages/10.png"
import image11 from "../../assets/quickImages/11.png"
import image12 from "../../assets/quickImages/12.png"
import image13 from "../../assets/quickImages/13.png"
import image14 from "../../assets/quickImages/14.png"
import image15 from "../../assets/quickImages/15.png"
import image16 from "../../assets/quickImages/16.png"
import image17 from "../../assets/quickImages/17.png"
import image18 from "../../assets/quickImages/18.png"
import image19 from "../../assets/quickImages/19.png"
import image20 from "../../assets/quickImages/20.png"
import image21 from "../../assets/quickImages/21.png"
import image22 from "../../assets/quickImages/22.png"
import image23 from "../../assets/quickImages/23.png"
import image24 from "../../assets/quickImages/24.png"
import image25 from "../../assets/quickImages/25.png"
import image26 from "../../assets/quickImages/26.png"
import image27 from "../../assets/quickImages/27.png"
import image28 from "../../assets/quickImages/28.png"
import image29 from "../../assets/quickImages/29.png"
import image30 from "../../assets/quickImages/30.png"



const Calculation = () => {
	const [value, setValue] = useState(1)

	const images = [image1, image2, image3, image4, image5, image6, image7, image8, image9, image10, image11, image12, image13, image14, image15, image16, image17, image18, image19, image20, image21, image22, image23, image24, image25, image26, image27, image28, image29, image30]

	const [prewImage, setPrewImage] = useState(images[0])

	useEffect(() => {
		const intervalId = setInterval(() => {
			setPrewImage(images[Math.floor(Math.random() * images.length)]);
		}, 300)

		return () => clearInterval(intervalId);
	}, [])


	return (
		<section className="calculation-section">
			<Container>
				<div className="calculation-warpper">
					<div className="calculation-header">
						<h5 className="title d-flex justify-content-center align-items-center">
							<span className="text-center d-block">Mint NFT</span>
						</h5>
					</div>
					<div className="calculation-body d-flex justify-content-center align-items-center">
						<img style={{ width: "100%" }} src={prewImage} alt="" />
					</div>
					<div className="calculation-btns d-flex justify-content-between align-items-center">
						<div className="changing-btns d-flex">
							<button onClick={() => value < 5 && setValue(value + 1)} className="btn shadow-none"><BsPlus /></button>
							<button onClick={() => value !== 1 && setValue(value - 1)} className="btn shadow-none"> <FiMinus /> </button>
						</div>
						<div className="changing-btns">
							<input readOnly className="form-control text-center" type="number" value={value < 10 ? "0" + value : value} />
						</div>
						<div className="mint-btn">
							<Button
								text="MINT"
								classes={`btn--base w-100 subscribeButton text-dark fw-bold`}
								type="submit"
							/>
						</div>
					</div>

					<div className="calculation-footer d-flex justify-content-between align-items-center">
						<span><span className="colored">0 /</span> 4,500 <span className="colored">MINTED</span></span>
						<span>0 BNB / NFT</span>
					</div>

				</div>
			</Container>
		</section>
	);
};

export default Calculation;
